var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{staticClass:"base-side-bar",attrs:{"default-active":_vm.$route.path,"collapse":_vm.isCollapse}},[_vm._l((_vm.meuns),function(item){return [(_vm.onlyOneMenuItem(item))?_c('MenuItem',{key:item.path,attrs:{"menuItem":item}}):_vm._e(),(_vm.isMenuGroup(item))?_c('SubMenu',{key:item.path,attrs:{"menuItem":item}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }